import { PaasTenant } from "./paas-tenant"

class Page{
    static data

    static async getPageInfo(route){
        if(!this.data){
            this.data = await PaasTenant.getPageList()
        }
        return this.data[route]
    }
    static async getPageInfoM(route){
        if(!this.data){
            this.data = await PaasTenant.getPageListM()
        }
        return this.data[route]
    }
}

export {
    Page
}


// WEBPACK FOOTER //
// ./src/models/page.js